import { createGlobalStyle } from "styled-components";

/**
 * colors of global css
 * contains hover and active state of each color
 */
export const COLORS = {
  primary: "#2B328B",
  "primary-hover": "#e13d00",
  "primary-active": "#c73600",

  secondary: "#2B328B",
  "secondary-hover": "#161b54",
  "secondary-active": "#1d2266",

  hot: "#FF004F",
  "hot-hover": "#df2a41",
  "hot-active": "#c22438",

  support: "#108BFF",
  "support-hover": "#0e7ae0",
  "support-active": "#0c6ac3",

  correct: "#11A26C",
  "correct-hover": "#0e8a5c",
  "correct-active": "#0b724c",

  error: "#B50000",
  "error-hover": "#9f0000",
  "error-active": "#890000",

  "black-1": "#373737",
  "black-2": "#4f4e4e",
  "black-3": "#757575",
  pink: "#EE2A7B",
  "blue-1": "#009CDE",
  "blue-sky": "#D2EAFF",
  "gray-1": "#606060",
  gray: "#d5d5d5",
  "gray-2": "#60606080",
  "gray-3": "#F5F5F5",
  "white-1": "#f7f7f7",
  "dark-blue": "#001860",
};

/**
 * list of font sizes in global css
 * these are in px
 */ //                     0  1   2   3   4   5   6   7   8   9
export const FONT_SIZES = [8, 10, 12, 14, 16, 18, 20, 22, 24, 26];

/**
 * list of sizes in global css
 * these are in px
 */ //                0  1  2   3   4   5   6   7   8
export const SIZES = [4, 8, 12, 16, 20, 24, 32, 48, 64];

/**
 * list of Border radiuses in global css
 * these are in px
 */ //                        0  1  2   3   4   5
export const BORDER_RADIUS = [3, 6, 10, 12, 16, 100];

const globalVariables = {
  colors: "",
  fontSizes: "",
  sizes: "",
  radiuses: "",
};

/**
 * color variables in global css.
 * you can call theme with var(--hig-color-colorName)
 */
for (const [colorName, colorValue] of Object.entries(COLORS)) {
  globalVariables.colors += `--hig-color-${colorName}: ${colorValue};\n`;
}

/**
 * font size variables in global css.
 * call theme with var(--hig-font-number)
 * number is index of selected font size in FONT_SIZES
 */
FONT_SIZES.forEach((fontItem, fontItemIndex) => {
  globalVariables.fontSizes += `--hig-font-${fontItemIndex}: ${fontItem}px;\n`;
});

/**
 * size variables in global css.
 * call theme with var(--hig-size-number)
 * number is index of selected size in SIZES
 */
SIZES.forEach((sizeItem, sizeItemIndex) => {
  globalVariables.sizes += `--hig-size-${sizeItemIndex}: ${sizeItem}px;\n`;
});

/**
 * border radius variables in global css.
 * you can call theme with var(--hig-radius-Number)
 * number is index of selected size in BORDER_RADIUSES
 */
BORDER_RADIUS.forEach((radiusItem, radiusItemIndex) => {
  globalVariables.radiuses += `--hig-radius-${radiusItemIndex}: ${radiusItem}px;\n`;
});

// all the global css comes to gether here
export const CssGlobalVariables = createGlobalStyle`
    :root {
        ${globalVariables.colors}
        ${globalVariables.fontSizes}
        ${globalVariables.sizes}
        ${globalVariables.radiuses}
    }
`;

/**
 * @param {String | Number} value
 * @param {Boolean} isList
 * @returns {True | False} that shows if value is in type format or not
 */
const isTypeStyle = (value, isList = false) => {
  return new RegExp(`^type-${isList ? `[0-9]` : "."}+$`).test(value);
};

/**
 *
 * @param {String | Number} value
 * @param {Boolean} isList
 * @returns match type of isTypeStyle function
 */
const getTypeStyle = (value, isList) => {
  if (isList && isTypeStyle(value, true)) {
    return parseInt(value.match(/^type-(\d)+$/)[1]);
  } else if (!isList && isTypeStyle(value, false)) {
    return value.match(/^type-(.+)$/)[1];
  } else {
    return null;
  }
};

/**
 * @param {Boolean} isList
 * @param {String | Number} value
 * @param {Array} list
 * @param {String} postfix
 * @returns an value or an String from list wich contains value type.
 */
export const getTypeValue = (isList, value, list, postfix = "") => {
  if (isList && typeof value === "number") {
    return `${value}${postfix}`;
  } else if (isList && list.length === 0) {
    return value;
  }
  const valueType = getTypeStyle(value, isList);
  if (valueType !== null) {
    return `${
      list[isList ? valueType % list.length : valueType] || ""
    }${postfix}`;
  } else {
    return value;
  }
};

// all variables of global css
export const cssVariables = {
  colors: COLORS,
  fontSizes: FONT_SIZES,
  sizes: SIZES,
  radius: BORDER_RADIUS,
};
